import { ref } from 'vue';
import dayjs from 'dayjs';

/**
 * Global reactive date-time service that updates every minute
 * Can be used throughout the application to access the current time
 */

// Create a reactive reference to the current date-time that will be updated periodically
export const flowingTime = ref(dayjs());

// Initialize the timer
let timer: number | null = null;

/**
 * Start the global date-time timer
 * This should be called once during application initialization
 */
export function startGlobalDateTimeTimer() {
  if (timer !== null) {
    return;
  }
  
  // Update the current time every 60 seconds (1 minute)
  timer = window.setInterval(() => {
    flowingTime.value = dayjs(new Date());
  }, 5000);

  // Log that the timer has started
  console.log('Global date-time timer started');
}

/**
 * Stop the global date-time timer
 * This should be called when the application is shutting down
 */
export function stopGlobalDateTimeTimer() {
  if (timer !== null) {
    clearInterval(timer);
    timer = null;
    console.log('Global date-time timer stopped');
  }
}
